import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=13241512&scoped=true"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"
import style0 from "./appMain.vue?vue&type=style&index=0&id=13241512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13241512",
  null
  
)

export default component.exports